






































import { activityLogName } from "@/lib/utility/activityLogName";
import { detailedDate } from "@/lib/utility/date-helper";
import DarkModeHighlightMixin from "@/mixins/DarkModeHighlightMixin.vue";
import PermissionMixin from "@/mixins/PermissionMixin.vue";
import { IActivityLog } from "@/models/activity-log.entity";
import { ITag } from "@/models/tag.entity";
import { ActivityTypeEnum } from "@/lib/enum/activity-type.enum";
import { TagModule } from "@/store/modules/tag.store";
import { mixins } from "vue-class-component";
import { Component, Prop } from "vue-property-decorator";
import ContextMenu from "../utility/ContextMenu.vue";
import TimeLineItemText from "../utility/TimeLineItemText.vue";
import ActivityTimeLineItemDelete from "./ActivityTimeLineItemDelete.vue";
import TagChip from "../tag/TagChip.vue";

@Component({
  components: { TimeLineItemText, ActivityTimeLineItemDelete, ContextMenu, TagChip }
})
export default class ActivityTimeLineItemTags extends mixins(DarkModeHighlightMixin, PermissionMixin) {
  @Prop({})
  activityLogEntry!: IActivityLog;

  get name() {
    return activityLogName(this.activityLogEntry);
  }

  get isAdd() {
    return ActivityTypeEnum.CREATE_TAG === this.activityLogEntry.activity;
  }

  get date() {
    if (this.activityLogEntry.timestamp?.created) {
      const locale = this.$t("utility.toLocalDateString").toString() || "de-de";
      return detailedDate(this.activityLogEntry.timestamp?.created, locale);
    }
    return this.$t("sign.DocumentDetail.noDate");
  }

  get textStart() {
    const name = this.name;
    const activityKey = this.isAdd ? ActivityTypeEnum.CREATE_TAG : ActivityTypeEnum.DELETE_TAG;

    return this.$t(`timeLine.ActivityTimeLineItemTags.${activityKey}.start`, {
      name
    });
  }

  get textEnd() {
    const date = this.date;
    const activityKey = this.isAdd ? ActivityTypeEnum.CREATE_TAG : ActivityTypeEnum.DELETE_TAG;

    return this.$t(`timeLine.ActivityTimeLineItemTags.${activityKey}.end`, {
      date
    });
  }

  get tags(): ITag[] {
    const tags: ITag[] = [];

    if (this.activityLogEntry.target) {
      this.activityLogEntry.target.forEach(t => {
        const tag = this.getTagDetails(t.refId);
        if (tag) {
          tags.push(tag);
        }
      });
    }

    return tags;
  }

  getTagDetails(tagId: string) {
    return TagModule.maps.id.get(tagId)[0];
  }

  hasValidTags(): boolean {
    return this.tags.length > 0;
  }

  static hasValidTagsForActivity(activityLogEntry: IActivityLog): boolean {
    if (!activityLogEntry.target || activityLogEntry.target.length === 0) {
      return false;
    }

    // Check if any of the referenced tags actually exist
    return activityLogEntry.target.some(t => {
      const tag = TagModule.maps.id.get(t.refId)[0];
      return tag !== undefined;
    });
  }
}
